import { CASES } from "./constants";

/**
 * Updates update engine-related state in the Redux store.
 * @param {Object} payload - State properties to merge into the updateEngine slice
 */
export const updateUpdateEngine = (payload) => {
  return { type: CASES.UPDATE_UPDATE_ENGINE, payload };
};

/**
 * Updates a specific field in the update engine search form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'filterForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateUpdateEngineSearchForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_UPDATE_ENGINE_SEARCH_FORM,
    payload: { key, data },
  };
};

/**
 * Resets the update engine state to initial values, preserving dropdown options and sort preference.
 */
export const clearUpdateEngine = () => {
  return { type: CASES.CLEAR_UPDATE_ENGINE, payload: {} };
};

/**
 * Resets the job view modal state including tasks and selected job.
 */
export const clearJobViewModal = () => {
  return { type: CASES.CLEAR_JOB_VIEW_MODAL, payload: {} };
};
